// Site guard (design/DOMAIN_SPLIT.md, "Route ownership"): on the Aqueduct
// build, nothing in this group is prerendered, so no Iliad HTML exists in that
// deploy's output, and this load rejects runtime requests.
import { error } from '@sveltejs/kit';
import { IS_AQUEDUCT } from '$lib/site';

export const prerender = !IS_AQUEDUCT;

export function load(): void {
	if (IS_AQUEDUCT) {
		error(404, 'Not Found');
	}
}
